import { RecommendationChannel } from '@packages/shared';
import { Page } from '../constants/routes';

export enum ProductGridSlotComponent {
  RecommendationsContainer = 'RecommendationsContainer',
  Text = 'Text',
}

interface ProductGridSlotConfigItemBase {
  component: ProductGridSlotComponent;
  categoryLevel?: number;
  repeat: boolean;
  page: Page;
  positions: number[];
}

interface ProductGridSlotConfigRecommendationsContainer extends ProductGridSlotConfigItemBase {
  component: ProductGridSlotComponent.RecommendationsContainer;
  props: {
    recommendationChannel: RecommendationChannel;
  };
}

interface ProductGridSlotConfigText extends ProductGridSlotConfigItemBase {
  component: ProductGridSlotComponent.Text;
  props: {
    children: string | JSX.Element;
  };
}

export type ProductGridSlotConfigItem = ProductGridSlotConfigRecommendationsContainer | ProductGridSlotConfigText;

export type ProductGridSlotConfig = ProductGridSlotConfigItem[];
